export default __webpack_public_path__ + "static/BerkshireHathaway-6e2d2a1c15cf92335fd1520bd94d9993.svg";